import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

const SITE_NAME = "St. George Real Estate — Neil Gibbs";
const BASE_URL = "https://www.stgeorgerealestate.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/st-george-og-thumbnail.png`;

const clampDescription = (text: string) => {
  if (text.length <= 160) return text;
  return text.slice(0, 157).trimEnd() + "...";
};

const SEOHead = ({
  title,
  description,
  path,
  noindex,
  ogTitle,
  ogDescription,
  ogImage,
}: SEOHeadProps) => {
  const url = `${BASE_URL}${path}`;
  const resolvedOgTitle = ogTitle ?? (title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`);
  const resolvedOgDescription = clampDescription(ogDescription ?? description);
  const resolvedOgImage = ogImage ?? DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Per-route Open Graph */}
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={resolvedOgImage} />

      {/* Per-route Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedOgTitle} />
      <meta name="twitter:description" content={resolvedOgDescription} />
      <meta name="twitter:image" content={resolvedOgImage} />
    </Helmet>
  );
};

export default SEOHead;
